<template>
	<div class="login">
		<v-overlay :value="true" z-index="1000">
			<v-progress-circular
			indeterminate
			size="100"
			></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
import {
	mapActions
} from 'vuex'

export default {
	components: {},
	methods: {
		...mapActions('auth', ['loginsso']),
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Masuk');
		this.loginsso({
			token: this.$route.params.token
		}).then(() => {
			const { redirect } = this.$route.query;

			if (redirect) {
				if (redirect == 'undefined') {
					this.$router.push({
						name: "home"
					})
				} else {
					window.location = redirect
				}
			} else {
				this.$router.push({
					name: "home"
				})
			}
		}).catch(() => {
			this.$router.push({
				name: "login"
			})
		})
	}
};
</script>
